(() => {
  const opener = document.querySelector('[data-workshop-preferences-open]');
  const dialog = document.getElementById(opener?.getAttribute('aria-controls'));
  if (!opener || typeof dialog?.showModal !== 'function') return;
  let bodyWasLocked = false;

  opener.addEventListener('click', () => {
    if (dialog.open) return;
    bodyWasLocked = document.body.classList.contains('overflow-hidden');
    dialog.showModal();
    document.body.classList.add('overflow-hidden');
  });
  dialog.querySelector('[data-workshop-preferences-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    dialog.close();
  }, {capture: true});
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (!bodyWasLocked) document.body.classList.remove('overflow-hidden');
    opener.focus({preventScroll: true});
  });
})();
